import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { IntegrationsApiService } from '@recruitee/integrations-http';
import {
  IntegrationKinds,
  IntegrationsClientConfig,
  IntegrationsCredentials,
} from '@recruitee/integrations-types';
import type { Partner } from '@recruitee/integrations-types';

import { IntegrationKindToken } from './integration-kind.token';
import { PartnerToken } from './partner.token';

@Injectable()
export class ContextualIntegrationsApiService extends IntegrationsApiService {
  constructor(
    http: HttpClient,
    config: IntegrationsClientConfig,
    integrationsCredentials: IntegrationsCredentials,
    @Inject(IntegrationKindToken) integrationKind?: IntegrationKinds,
    @Inject(PartnerToken) partner?: Partner,
  ) {
    super(http, config, integrationsCredentials);

    if (integrationKind) {
      this.context = integrationKind;
    } else if (partner) {
      this.context = `p/${partner.codename}`;
    }
  }
}
